/**
 * The CloseButtonEvent is dispatched when the user presses a CloseButton.
 *
 * It carries the button's `dispatcher`, which says what the button closes: several CloseButtons can sit under the same listener — one in each dialog — and every one of them dispatches this same type, so the dispatcher is how a listener tells them apart.
 */
export default class CloseButtonEvent extends Event {
	/**
	 * The static CLOSE_BUTTON_CLICKED type is dispatched when the CloseButton is clicked or while focused, the Space or Enter key is pressed.
	 *
	 * Example: addEventListener(CloseButtonEvent.CLOSE_BUTTON_CLICKED, (event: CloseButtonEvent) => {});
	 */
	public static CLOSE_BUTTON_CLICKED = 'CloseButtonEvent.closeButtonClicked';

	/** What the pressed button closes, as the button was told. */
	public get dispatcher(): string {
		return this.#dispatcher;
	}

	#dispatcher: string;

	public constructor(dispatcher: string) {
		super(CloseButtonEvent.CLOSE_BUTTON_CLICKED, { bubbles: true });
		this.#dispatcher = dispatcher;
	}
}
